import { combineReducers } from 'redux';
import qs from 'qs';

import { Api } from '../../../core/api';

const hashtagsListApi = new Api({
  initialData: [],
  useEagleApi: true,
  namespace: 'HASHTAGS_LIST',
  url: '/internal-intranet/search/hashtags',
});

const hashtagItemApi = new Api({
  initialData: {},
  useEagleApi: true,
  namespace: 'HASHTAG_ITEM',
});

const checkHashtagItemApi = new Api({
  initialData: {},
  useEagleApi: true,
  namespace: 'CHECK_HASHTAG_ITEM',
});

const createHashtagApi = new Api({
  namespace: 'CREATE_HASHTAG',
  useEagleApi: true,
  options: {
    method: 'POST',
  },
  throwable: true,
  url: `/internal-intranet/hashtags`,
});

const editHashtagApi = new Api({
  namespace: 'EDIT_HASHTAG',
  useEagleApi: true,
  options: {
    method: 'PUT',
  },
  throwable: true,
});

const deleteHashtagApi = new Api({
  namespace: 'DELETE_HASHTAG',
  useEagleApi: true,
  options: {
    method: 'DELETE',
  },
  throwable: true,
});

export const fetchHashtags = ({ search, hash }: any) => {
  let searchPhrase = '';

  if (hash) {
    const searchString = hash.split('#')[1];

    searchPhrase = search
      ? `&search=${searchString}`
      : `?search=${searchString}`;
  }
  const params = qs.parse(search?.slice(1) as string);
  const searchParams = qs.parse(searchPhrase?.slice(1) as string);
  const body = JSON.stringify({
    page: +params.page || 0,
    pageSize: +params.limit || 10,
    sort: {
      order: [
        { direction: 'ASC', property: 'name' },
        { direction: 'ASC', property: 'slug' },
      ],
    },
    filter: searchParams.search
      ? {
          filters: [
            {
              property: 'name',
              type: 'containsIgnoreCase',
              value: searchParams.search,
            },
            {
              property: 'slug',
              type: 'containsIgnoreCase',
              value: searchParams.search,
            },
          ],
        }
      : null,
  });

  return hashtagsListApi.fetch({
    options: {
      method: 'POST',
      body,
    },
  });
};

export const fetchHashtagInfo = (id: string) =>
  hashtagItemApi.fetch({
    url: `/internal-intranet/hashtags/${id}`,
  });

export const checkHashtagInfo = (id: string) =>
  checkHashtagItemApi.fetch({
    url: `/internal-intranet/hashtags/${id}`,
  });

export const resetHashtagInfo = hashtagItemApi.reset;

export const createHashtag = (data: any) =>
  createHashtagApi.fetch({ options: { body: JSON.stringify(data) } });

export const editHashtag = (id: string, data: any) =>
  editHashtagApi.fetch({
    options: { body: JSON.stringify(data) },
    url: `/internal-intranet/hashtags/${id}`,
  });

export const deleteHashtag = (id: string) =>
  deleteHashtagApi.fetch({
    options: { body: JSON.stringify({ ids: [id] }) },
    url: `/internal-intranet/hashtags`,
  });

const checkSlugsApi = new Api({
  useEagleApi: true,
  options: {
    method: 'GET',
  },
});

export const checkSlugs = (slug: string) => {
  if (slug) {
    return checkSlugsApi.simpleFetch({
      url: `/internal-intranet/hashtags/has-slug/${slug}`,
    });
  }
  return false;
};

export const reducer = combineReducers({
  item: hashtagItemApi.reducer,
  list: hashtagsListApi.reducer,
});
